import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaCardDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaTagDirective} from 'angular-awesome';
import {WaDividerDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
@Component({
	selector:'jwebmp-plugin-fontawesome',
	templateUrl:'./FontAwesomePluginPage.html',
	styles: [],
	styleUrls:['./FontAwesomePluginPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaCardDirective,
		WaTextDirective,
		WaTagDirective,
		WaDividerDirective,
		MarkdownComponent,
],
	standalone:true
})
export class FontAwesomePluginPage
{
	mdContent_93 = `\`\`\`xml
<dependency>
  <groupId>com.jwebmp.plugins</groupId>
  <artifactId>font-awesome</artifactId>
</dependency>
\`\`\``;
	mdContent_94 = `\`\`\`kotlin
implementation("com.jwebmp.plugins:font-awesome:2.0.0-SNAPSHOT")
\`\`\``;
	mdContent_95 = `\`\`\`json
"@fortawesome/free-solid-svg-icons": "^7.2.0"
"@fortawesome/angular-fontawesome": "^4.0.0"
"@fortawesome/free-brands-svg-icons": "^6.2.2"
"@fortawesome/fontawesome-svg-core": "^7.2.0"
\`\`\``;
	mdContent_96 = `\`\`\`java
// Solid icon
FontAwesome icon = new FontAwesome(
    FontAwesomeStyles.Solid,
    FontAwesomeIcons.cog);

// Brand icon
FontAwesome github = IFontAwesome.createIcon(
    FontAwesomeBrandIcons.github,
    FontAwesomeStyles.Brand);

// With animation
icon.spin().setSize(FontAwesomeSizes.Fa3x);
\`\`\``;
	mdContent_97 = `\`\`\`java
var layers = new FontAwesomeLayers();
layers.add(new FontAwesome(FontAwesomeStyles.Solid, FontAwesomeIcons.envelope));
layers.add(new FontAwesomeLayerCounter("99+"));
\`\`\``;
	mdContent_98 = `\`\`\`java
// Solid icon
FontAwesome icon = new FontAwesome(
    FontAwesomeStyles.Solid,
    FontAwesomeIcons.cog);

// Brand icon
FontAwesome github = IFontAwesome.createIcon(
    FontAwesomeBrandIcons.github,
    FontAwesomeStyles.Brand);

// With animation
icon.spin().setSize(FontAwesomeSizes.Fa3x);
\`\`\``;
}
